"use client";

import { Mail, MapPin, Phone, Instagram, Facebook, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-foreground-dark/20 animate-pulse rounded" />
        <div className="h-4 w-20 bg-foreground-dark/20 animate-pulse rounded" />
        <div className="h-4 w-28 bg-foreground-dark/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-white hover:text-white transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
    </nav>;
}
function FooterMenu() {
  return <MenuProvider menu_id="12">
      <FooterMenuConsumer />
    </MenuProvider>;
}
export default function Footer() {
  return <footer className="bg-primary-dark text-foreground-dark py-8 px-2 sm:px-4">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-[260px_minmax(420px,1fr)_minmax(520px,1fr)] gap-6 items-start">
          {}
          <div className="flex items-start justify-start">
            <img src="https://hopeful-ram-2.10web.cloud/wp-content/uploads/2026/01/Gemini_Generated_Image_s88ygvs88ygvs88y-e1768867953225.png" alt="Pro Group" className="h-72" />
          </div>

          {}
          <div className="flex flex-col gap-2">
            {}
            <p className="text-sm text-white">
              <span className="font-semibold">Nos ubicamos en:</span>{" "}
              <span className="text-white/80 font-normal">
                Combarbalá 0788, La Granja, Santiago
              </span>
            </p>

            <div className="w-full">
              <div className="relative z-10 rounded-lg overflow-hidden shadow-medium border border-border">
                <div className="w-full h-64">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3327.2744985769515!2d-70.6399!3d-33.5327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d0f5b5b5b5b5%3A0x0!2sCombarbal%C3%A1%200788%2C%208780636%20Santiago%2C%20La%20Granja%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1sen!2scl!4v1234567890123!5m2!1sen!2scl&maptype=satellite" style={{
                  border: 0
                }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Pro Group: Combarbalá 0788, Santiago, La Granja" className="w-full h-full" />
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-8 justify-items-start">
            {}
            <div className="flex flex-col gap-3">
              <h3 className="text-sm font-semibold text-white mb-1">
                Contactos
              </h3>

              <Link to="tel:+56927146255" className="flex items-center gap-2 text-sm text-white hover:text-white hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <Phone className="size-4 shrink-0" />
                <span>+56 9 2714 6255</span>
              </Link>

              <Link to="https://wa.me/56927146255" newTab className="flex items-center gap-2 text-sm text-white hover:text-white hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <MessageCircle className="size-4 shrink-0" />
                <span>+56 9 2714 6255</span>
              </Link>

              <Link to="mailto:contacto@promaquinas.cl" className="flex items-center gap-2 text-sm text-white hover:text-white hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <Mail className="size-4 shrink-0" />
                <span>contacto@promaquinas.cl</span>
              </Link>

              <div className="flex items-start gap-2 text-sm text-white">
                <MapPin className="size-4 shrink-0 mt-0.5" />
                <span>Santiago, Chile</span>
              </div>

              <Link to="https://instagram.com/promaquinas_cl" newTab className="flex items-center gap-2 text-sm text-white hover:text-white hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <Instagram className="size-4 shrink-0" />
                <span>@promaquinas_cl</span>
              </Link>

              <Link to="https://www.facebook.com/profile.php?id=61584618495406" newTab className="flex items-center gap-2 text-sm text-white hover:text-white hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <Facebook className="size-4 shrink-0" />
                <span>ProMaquinas</span>
              </Link>
            </div>

            {}
            <div className="flex flex-col gap-3">
              <h3 className="text-sm font-semibold text-white mb-1">
                Enlaces rápidos
              </h3>
              <FooterMenu />
            </div>

            {}
            <div className="flex flex-col gap-3">
              <h3 className="text-sm font-semibold text-white mb-1">
                Horarios
              </h3>

              <div className="text-sm text-white leading-tight space-y-2">
                <div className="flex flex-col">
                  <span className="font-medium">Lunes a Viernes</span>
                  <span className="text-white/90">09:00 - 18:00</span>
                </div>

                <div className="flex flex-col">
                  <span className="font-medium">Sábado</span>
                  <span className="text-white/90">Cerrado</span>
                </div>

                <div className="flex flex-col">
                  <span className="font-medium">Domingo</span>
                  <span className="text-white/90">Cerrado</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-8 pt-6 border-t border-foreground-dark/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white">
            <p>© 2026 Promaquinas. Todos los derechos reservados.</p>
            <div className="flex gap-4">
              <Link to="/privacy" className="text-white hover:text-white transition-colors duration-[var(--duration-medium)]">
                Política de Privacidad
              </Link>
              <Link to="/terms" className="text-white hover:text-white transition-colors duration-[var(--duration-medium)]">
                Términos de Servicio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}